import AsnIndex from "@/components/flux_oms/asn/AsnIndex.vue";
import AsnUpload from "@/components/flux_oms/asn/AsnUpload.vue";
import AsnCreate from "@/components/flux_oms/asn/AsnCreate.vue";
import AsnDetail from "@/components/flux_oms/asn/AsnDetail.vue";
import AsnUpdate from "@/components/flux_oms/asn/AsnUpdate.vue";

let routesAsn= [
    {
        path: '',
        meta: {
            title: "ASN (Inbound)",
        },
        name: "AsnIndex",
        component: AsnIndex
    },
    {
        path: 'create',
        meta: {
          title: "ASN (Inbound) Create",
        },
        name: "AsnCreate",
        component: AsnCreate
    },

    {
        path: 'upload',
        meta: {
          title: "Asn (Inbound)",
        },
        name: "AsnUploads",
        component: AsnUpload
    },

    {
        path: 'detail/:id',
        meta: {
          title: "ASN (Inbound) Detail",
        },
        name: "AsnDetail",
        component: AsnDetail
    },


    {
      path: 'edit/:id',
      meta: {
        title: "ASN (Inbound) Update",
      },
      name: "AsnUpdate",
      component: AsnUpdate
  },
     
   
     
    // {
    //     path: 'edit/:id',
    //     meta: {
    //       title: "Master SKU Edit",
    //     },
    //     name: "MasterSKUEdit",
    //     component: MasterSKUEdit
    // },
    
]

export default routesAsn
  